export default __webpack_public_path__ + "static/media/left_character.c2bc19b0.png";